import React from 'react'
import Button from '@mui/material/Button'

import { useLoginToAppAccount } from '~/client/hooks/appAccounts.js'

export default function AppAccountLoginButton({
  disabled = false,
  variant = 'contained',
  color = 'primary',
  appAccountId,
  returnTo,
  ...props
}){
  console.log({ appAccountId, returnTo })
  const loginToAppAccount = useLoginToAppAccount({ appAccountId, returnTo })
  const onClick = React.useCallback(
    event => {
      event.preventDefault()
      loginToAppAccount.call({ appAccountId, returnTo })
    }
  )
  return <Button {...{
    ...props,
    disabled: disabled || loginToAppAccount.pending,
    variant,
    color,
    onClick,
  }}>
    {'Login'}
  </Button>
}
